/* eslint-disable camelcase */
import { useContext } from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Chip, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { formatDateHour } from 'utils/helpers';

import {
  SpecialistContext,
  getSpecialistType,
} from 'context/SpecialistContext/SpecialistContext';
import { SpecialistRole, SpecialistType } from 'services/index';
import { RecordQuestion } from 'services/user';

import * as S from './styles';

export function RecordItem({
  title_key,
  allowed_roles,
  content,
  date,
}: RecordQuestion) {
  const intl = useIntl();
  const { specialistInfo } = useContext(SpecialistContext);
  const specialistType = getSpecialistType(specialistInfo?.groups);

  const shared =
    allowed_roles.includes(SpecialistRole.TC) &&
    specialistType !== SpecialistType.TC;

  return (
    <S.Wrapper>
      <Box display="inline-flex" alignItems="center" gap={1} flexWrap="wrap">
        <S.Title>{intl.formatMessage({ id: title_key })}</S.Title>
        {content && (
          <>
            <InfoOutlinedIcon fontSize="small" />
            {date && (
              <Typography variant="caption">
                {intl.formatMessage(
                  {
                    id: 'CAREMATRIXCPTC.RECORDTABFIELD.LASTUPDATE',
                  },
                  {
                    date: formatDateHour(date, {
                      locale: intl.locale,
                      enableReplaceColonWithH: false,
                      omitMinutesWhenZero: false,
                    }),
                  },
                )}
              </Typography>
            )}
            {shared && (
              <Chip
                label={intl.formatMessage({
                  id: 'CAREMATRIXCPTC.RECORDTABLABEL.SHARED',
                })}
                size="small"
              />
            )}
          </>
        )}
      </Box>

      <Typography variant="body2">{content}</Typography>
    </S.Wrapper>
  );
}
